import { useAppSelector, useAppTranslation } from 'app/hooks';
import React, { useCallback, useState } from 'react';
import vinpay from 'assets/images/deposit-methods/vinpay.png';
import paypalLogo from 'assets/images/paypal-logo.png';
import visaLogo from 'assets/images/visa-logo.png';
import visaMaster from 'assets/images/visa_master.png';
import masterCardLogo from 'assets/images/master-card-logo.png';
import crypto from 'assets/images/deposit-methods/crypto.png';
import wallet from 'assets/icons/wallet_icon.png';
import Typo from 'consts/typography';
import WithdrawGuide from './Modals/WithdrawGuide';
import { FaRegLightbulb } from 'react-icons/fa';
import ButtonsDepositVinpay from 'components/Commons/ButtonsDepositVinpay';
import VinpayConnectModal from './Modals/VinpayConnectModal';
import OnramperModal from './Modals/OnramperModal';
import { showInfoModal } from 'components/Modals/CommonModals';
import userApi from 'api/userApi';
import { Modal } from 'antd';
import useUserDetail from 'hooks/useUserDetail';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import WarningIcon from 'assets/icons/WarningIcon';
import CloseIcon from 'assets/icons/CloseIcon';
import useThemes from 'hooks/useThemes';
import { selectCurrentUser } from 'redux/userSlice';
import vinpayApi from 'api/vinpayApi';

interface PaymentMethodProps {
  id: number;
  title: string;
  image: string;
  type: 'deposit' | 'withdraw';
  order: number;
}

const paymentMethods: PaymentMethodProps[] = [
  // {
  //   id: 0,
  //   title: 'Crypto',
  //   image: crypto,
  //   type: 'deposit',
  //   order: 1,
  // },
  // {
  //   id: 1,
  //   title: 'Paypal',
  //   image: paypal,
  //   type: 'deposit',
  //   order: 2,
  // },
  // {
  //   id: 2,
  //   title: 'Stripe',
  //   image: stripe,
  //   type: 'deposit',
  //   order: 3,
  // },
  {
    id: 3,
    title: 'Vinpay',
    image: vinpay,
    type: 'deposit',
    order: 4,
  },
  // {
  //   id: 4,
  //   title: 'ACH Debit',
  //   image: banking,
  //   type: 'deposit',
  //   order: 5,
  // },
  {
    id: 5,
    title: 'Crypto',
    image: crypto,
    type: 'withdraw',
    order: 1,
  },
  // {
  //   id: 6,
  //   title: 'Card or ACH',
  //   image: banking,
  //   type: 'withdraw',
  //   order: 3,
  // },
  {
    id: 7,
    title: 'Crypto Wallets',
    image: wallet,
    type: 'deposit',
    order: 6,
  },
  {
    id: 8,
    title: 'Crypto Wallets',
    image: wallet,
    type: 'withdraw',
    order: 4,
  },
  {
    id: 9,
    title: 'Vinpay',
    image: vinpay,
    type: 'withdraw',
    order: 2,
  },
  { id: 10, title: 'Visa/Mastercard', image: visaMaster, type: 'deposit', order: 7 },
];

interface PaymentMethodsProps {
  handlePaymentMethodClick: (id: number) => void;
  type: 'deposit' | 'withdraw';
  redirectToSwap?: () => void;
}

const PaymentMethods: React.FunctionComponent<PaymentMethodsProps> = ({
  handlePaymentMethodClick,
  type,
  redirectToSwap,
}) => {
  const t = useAppTranslation();
  const { getUser } = useUserDetail();
  const handleResponseError = useHandleResponseError();
  const currentUser = useAppSelector(selectCurrentUser);
  const [showWithdrawGuide, setShowWithdrawGuide] = useState<boolean>(false);
  const [onramperLink, setOnramperLink] = useState<string | null>(null);
  const [showVinpayConnect, setShowVinpayConnect] = useState<boolean>(false);
  const { currentTheme } = useThemes();

  const openManualConnectVinpay = () => {
    setShowVinpayConnect(true);
  };

  const handleConnectVinpay = async () => {
    const { ok, error } = await userApi.createVinpayAccount();
    Modal.destroyAll();
    if (ok) {
      getUser();
    }
    if (error) {
      handleResponseError(error);
    }
  };

  const handleShowConnectVinpayModal = () => {
    showInfoModal({
      title: t('vinpay.connectModal.title'),
      content: (
        <div>
          <p>{t('vinpay.connectModal.content')}</p>
          <div className="ant-modal-confirm-btns">
            <button className="ant-btn btn-submit" onClick={() => handleConnectVinpay()}>
              {t('vinpay.connectModal.createNow')}
            </button>
          </div>
        </div>
      ),
      width: 400,
      icon: <WarningIcon />,
      onOk: () => openManualConnectVinpay(),
      okText: t('vinpay.connectModal.manualy'),
      closeIcon: <CloseIcon width="20" height="20" isDarkMode={currentTheme === 'dark'} />,
      closable: true,
    });
  };

  const getOnramperLink = useCallback(async () => {
    if (currentUser?.isVinpayConnected) {
      const { ok, body, error } = await vinpayApi.getOnramperLink();
      if (ok && body) {
        setOnramperLink(body.link);
      }
      if (error) {
        handleResponseError(error);
      }
    } else {
      handleShowConnectVinpayModal();
    }
  }, [currentUser]);

  return (
    <div className="cashier-payment-methods">
      {paymentMethods
        .filter((x) => x.type === type)
        .sort((a, b) => a.order - b.order)
        .map((paymentMethod) => (
          <div key={`payment-method-${paymentMethod.id} `}>
            <button
              className="payment-method vinpay-method"
              onClick={() => {
                if (paymentMethod.id === 10) {
                  getOnramperLink();
                } else {
                  handlePaymentMethodClick(paymentMethod.id);
                }
              }}
            >
              {paymentMethod.title === 'Vinpay' && (
                <>
                  <div className="visa-master-logo left">
                    <img src={visaLogo} alt="Visa" />
                    <img src={masterCardLogo} alt="mastercard" />
                  </div>
                  <div className="visa-master-logo right">
                    <img src={paypalLogo} alt="PAYPAL" />
                  </div>
                </>
              )}
              <div className="vinpay-method__content">
                <img src={paymentMethod.image} alt="payment method" />
                <p className="primary-text-color">{paymentMethod.title}</p>
              </div>
            </button>
            {paymentMethod.title === 'Vinpay' && paymentMethod.type === 'deposit' && (
              <>
                {/* <ButtonsDepositVinpay showConnectModal={handleShowConnectVinpayModal} />
                <div className="flex mt-10 justify-center">
                  <div className="turbo-div-item vinpay-method-btn w-100" onClick={getOnramperLink}>
                    {t('vinpay.connectModal.buyCrypto')}
                  </div>
                </div> */}
              </>
            )}
          </div>
        ))}
      {type === 'withdraw' && (
        <span className={`${Typo.p3}  span-link`} onClick={() => setShowWithdrawGuide(true)}>
          <FaRegLightbulb /> <span>{t('withdraw-guide.title')}</span>
        </span>
      )}
      <VinpayConnectModal
        visible={showVinpayConnect}
        closeModal={() => setShowVinpayConnect(false)}
        className="common-modal withdraw-modal"
        hiddenAutoCreate={true}
      />
      {!!onramperLink && (
        <OnramperModal
          isShow={!!onramperLink}
          onCancel={() => setOnramperLink(null)}
          onramperLink={onramperLink.replace('mode=buy,sell', 'mode=buy')}
        />
      )}
      <WithdrawGuide
        isShow={showWithdrawGuide}
        onCancel={() => setShowWithdrawGuide(false)}
        redirectToSwap={redirectToSwap}
      />
    </div>
  );
};

export default PaymentMethods;
